import React from 'react';
import {
    AisinoForm,
    AisinoFormItem,
    AisinoInput,
    AisinoPassword,
} from './baseComponent/form';
import {AisinoButton} from "./baseComponent/button";
import {AisinoMessage} from "./baseComponent/message";
import {post} from "./common/utils/http";
import cookie from "react-cookies";
import 'antd/dist/antd.css';
import {
    BRANCH_ID,
    BRN_NIN,
    BUSINESS_NAME,
    getLanguage,
    LEGAL_NAME,
    LOCATION_ID,
    LOGIN,
    TAXPAYER_ID,
    TIN,
    USER_ID,
    setButtonIdFun
} from "./source/js/common";
import BACKGROUND from "file-loader!./source/images/mypro/bg1.png";
import BACKGROUNDLOG from "file-loader!./source/images/mypro/kuang1_img.png";
import BACKGROUNDFORM from "file-loader!./source/images/mypro/kuang2_img.png";
import {aisinoInfoModal} from "./common/modal/AisinoModalMethod";
import {isEmpty} from "./common/utils/StringUtils";
import {dropByCacheKey, getCachingKeys} from "react-router-cache-route";
import {connect} from 'react-redux'
import AisinoRow from "./baseComponent/rowAndCol/AisinoRow";
import AisinoCol from "./baseComponent/rowAndCol/AisinoCol";
import ForgetPwd from "./forgetPwd";
import RegisterPage from "./registerPage";
import store from "./store";
import {refreshMenu} from "./store/actions";

const loginLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/login.js');
const layout = {
    labelCol: {span: 6},
    wrapperCol: {span: 10},
};
export const leftColLayout = {xs:{span:0},sm:{span:0}, md: 13, lg: 10 };

export const rightColLayout = {xs: 24,sm: 18,md: 11, lg: 10 };
const tailLayout = {
    wrapperCol: {offset: 6, span: 10},
};
const charTypeOptions = [
    { label: loginLan.email.label, value: 'line' },
    { label: loginLan.SMS.label, value: 'bar' },
];
const login_center={
    width: "100%",
    background: `url(${BACKGROUND}) no-repeat`,
    backgroundSize: "100% 500px",
    height:"500px",
}
const login_left={
    width: "100%",
    background: `url(${BACKGROUNDLOG}) no-repeat`,
    backgroundPosition: "center",
    backgroundSize: "100% 500px",
    height:"500px",
}
const login_right={
    width: "100%",
    background: `url(${BACKGROUNDFORM}) no-repeat`,
    backgroundSize: "100% 500px",
    height:"500px",
    paddingTop: "40px"
}
const SEND_SMS_CAPTCHA = "bar";
const SEND_EMAIL_CAPTCHA = "line";
class Login extends React.Component{
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            getOtpOverTimeTip:"",
            username: '',
            pwd: '',
            userId:'',
            starEmail:'',
            starMmobileNumber:'',
            encrypted:'',
            visible:false,
            loginVisible:true,
            value1:SEND_EMAIL_CAPTCHA,
            smsVisible:false,
            emailVisible:false,
            charType:'',
            sendBtText:loginLan.sendOTP.label,
            showOPT: false,
            disabled:false,
            loginTitle:loginLan.login.label,
            moreDetailsVisible:false,
            modal1Visible: false,
            modifytype:"",
            fdnValue:"",
            captchaId:''
        };
        this.sendType = SEND_EMAIL_CAPTCHA;
    }
    componentDidMount() {
        const that= this;
        if(sessionStorage.getItem("aogin") === "0"){
            this.setState({
                loginTitle:loginLan.login.label,
                visible:false,
                loginVisible:true,
                emailVisible:false,
                smsVisible:false,
            });
            sessionStorage.setItem("aogin","1")
        }
        this.captchaChange();
        setInterval(function(){
            that.captchaChange();
        }, 170000);
    }

    onFinish = values => {
        // AisinoMessage.info("您提交的数据是：" + JSON.stringify(values));
        // getCachingKeys().forEach(item => {
		// 	dropByCacheKey(item)
		// })
        this.clientLogin(values);
    };
    async clientLogin(data) {
        data.captcha_id=this.state.captchaId;
        const userInfo = await post('aisino/portalLogin/clientLogin',data)
            .then(response =>{
                if(!isEmpty(response)){
                    if(typeof response === 'object'){
                        cookie.save(LOGIN,"true");
                        cookie.save(USER_ID,response.userId);
                        cookie.save(LEGAL_NAME,response.legalName);
                        cookie.save("userId",response.userId);
                        sessionStorage.setItem("verifyLogin","1")
                        store.dispatch(refreshMenu());
                        this.formRef.current.resetFields();
                        this.refreshCaptcha();
                        this.props.history.push("/");

                        //2024-09-18 纳税人登录后设置登录人的按钮ids
                        setButtonIdFun(response.menuIdList);
                    }else{
                        cookie.remove(LOGIN);
                        cookie.remove(LEGAL_NAME);
                        cookie.remove(USER_ID);
                        cookie.remove("gridPageSizeParam");
                        cookie.remove("gridSizeListParam");
                        aisinoInfoModal(response);
                        this.refreshCaptcha();
                        sessionStorage.setItem("verifyLogin","0")
                    }
                }
            });
    }
    goBack(){
        getCachingKeys().forEach(item => {
            dropByCacheKey(item)
        })
        this.setState({
            loginTitle:loginLan.login.label,
            visible:false,
            loginVisible:true,
            emailVisible:false,
            smsVisible:false,
        });
        cookie.remove(LOGIN);
        cookie.remove(TIN);
        cookie.remove(USER_ID);
        cookie.remove(BUSINESS_NAME);
        cookie.remove(BRANCH_ID);
        cookie.remove(BRN_NIN);
        cookie.remove(LEGAL_NAME);
        cookie.remove(LOCATION_ID);
        cookie.remove(TAXPAYER_ID);
        cookie.remove("gridPageSizeParam");
        cookie.remove("gridSizeListParam");
    }
    async siteLogin(otp,stateParams) {
        if(isEmpty(otp)){
            AisinoMessage.info({
                key:"k1",
                content: loginLan.enterOTP,
                className: 'custom-class',
                style: {
                  marginTop: '20vh',
                }
            });
            return ;
        }
        const userInfo = await post('aisino/portalLogin/siteLogin',{
            'userName':stateParams.username,
            'pwd':stateParams.pwd,
            'userId':stateParams.userId,
            'encrypted':stateParams.encrypted,
            'captcha':otp
        }).then(response =>{
            if(isEmpty(response)){
                aisinoInfoModal(loginLan.canNotLogin)
                return ;
            }
            clearTimeout(this.timer);  //清除定时器
            if(response.reCode === 14000){
                cookie.remove("AOS_TOKENID_");
                cookie.save("AOS_TOKENID_",response.encryKey);
                this.props.foo(true)
                //his.props.foo1(true)
                sessionStorage.setItem("verifyLogin","1")
                this.setState({
                    loginTitle:loginLan.login.label,
                    visible:false,
                    loginVisible:true,
                    emailVisible:false,
                    smsVisible:false,
                    disabled:false,
                    sendBtText:loginLan.sendOTP.label
                });
                this.formRef.current.setFieldsValue({
                    username:"",
                    pwd:"",
                    otp:"",
                    chartGroups:SEND_EMAIL_CAPTCHA,
                })
                this.props.history.push("/");
            }else if(response.reCode == 14006 || response.reCode === 14007){
                if(response.reCode=== 14006){
                    this.setState({
                        modifytype:'firstLoginChangePwd'
                    })
                }
                if(response.reCode=== 14007){
                    this.setState({
                        modifytype:'pwdAfterEndDateChangePwd'
                    })
                }
                this.setState({ modal1Visible:true });
                this.formRef.current.setFieldsValue({
                    username:"",
                    pwd:"",
                    otp:"",
                    chartGroups:SEND_EMAIL_CAPTCHA,
                })
            }else{
                cookie.remove("AOS_TOKENID_");
                AisinoMessage.error({
                    className: 'custom-class',
                    style: {
                      marginTop: '20vh',
                    },
                    key:"k2",
                    content:response.msg
                });
            }
        });
    }
    RadioOnChartTypeChange = e => {
        this.setState({
            value1: e.target.value,
        });
        if(e.target.value == 'line'){
            this.setState({emailVisible:true,smsVisible:false});
            this.sendType = SEND_EMAIL_CAPTCHA;
        }
        else{
            this.setState({emailVisible:false,smsVisible:true});
            this.sendType = SEND_SMS_CAPTCHA;
        }
    }
    timeCallback = () => {
        this.time--;
        if(this.time>=0) {
            this.setState({
                disabled:true,
                sendBtText:loginLan.after + this.time + loginLan.second
            });
        }else{
            this.setState({
                disabled:false,
                sendBtText:loginLan.sendOTP.label
            });
            clearTimeout(this.timer);  //清除定时器
        }
    }
    toggleDiv = () =>{
         post("aisino/portalLogin/sendCaptcha",
            {
                'cChartType':this.sendType,
                'userId':this.state.userId,
                'userName':this.state.username,
                'encrypted':this.state.encrypted
            })
            .then(data => {
            this.time = data;
            this.timer = setInterval(this.timeCallback, 1000);  //设置定时器
        });
    }

    componentWillUnmount(){
        // 卸载异步操作设置状态
        this.setState = (state, callback) => {
            return;
        }
    }

    setModal1Visible(modal1Visible) {
		this.setState({ modal1Visible });
	  }
	  handleClose(){
        this.setState({
            loginTitle:loginLan.login.label,
            visible:false,
            loginVisible:true,
            emailVisible:false,
            smsVisible:false,
            modal1Visible:false
        });
	  }
    captchaChange(){
        this.refreshCaptcha();
    }
    refreshCaptcha(){
        if(this.formRef.current){
            this.formRef.current.setFieldsValue({captcha:''});
            let captcha_id = Math.random().toString(36).slice(-10);
            while (!captcha_id) {
                captcha_id = Math.random().toString(36).slice(-10);
            }
            this.state.captchaId=captcha_id;
            this.setState({})
        }
    }
    forgetPwdFun(){
        this.refs.forgetPwd.setModal1Visible(true);
    }
    registerNowFun(){
        this.refs.registerPage.setModal1Visible(true);
    }
    render(){
        const {value1,captchaId} = this.state;
        return (
            <div style={{...login_center,marginTop:(window.innerHeight-500-45)/2}} >
                <ForgetPwd ref={"forgetPwd"}/>
                <RegisterPage ref={"registerPage"}/>
                <AisinoRow justify="center">
                    <AisinoCol {...leftColLayout} id={"logingLeftCol"} style={login_left}>
                        <div >

                        </div>
                    </AisinoCol>
                    <AisinoCol {...rightColLayout} style={login_right}>
                        <div >
                            <div style={{display: "flex",justifyContent: "center",width:"95%"}}>
                                <AisinoForm  className={"x-axis"}  {...layout} name="login-ref"
                                             ref={this.formRef} onFinish={this.onFinish}>
                                    <div className="login-title">{this.state.loginTitle}</div>
                                    <div className="noneRequired">
                                        <AisinoFormItem
                                            label={loginLan.username}
                                            name="username"
                                            rules={[{required: true, message: loginLan.enterUsername}]}
                                            style={{display:this.state.loginVisible?"":"none"}}
                                        >
                                            <AisinoInput autoComplete="off" maxLength={100}
                                                         placeholder={loginLan.enterUsername}/>
                                        </AisinoFormItem>
                                        <AisinoFormItem
                                            label={loginLan.pwd}
                                            name="pwd"
                                            rules={[{required: true, message: loginLan.enterPwd}]}
                                            style={{display:this.state.loginVisible?"":"none"}}
                                        >
                                            <AisinoPassword maxLength={20} placeholder={ loginLan.enterPwd}/>
                                        </AisinoFormItem>

                                        {/*添加验证码*/}
                                        <AisinoRow>
                                            <AisinoCol span={18}>
                                                <AisinoFormItem
                                                    label={loginLan.captcha}
                                                    name="captcha"
                                                    rules={[{required: true, message: loginLan.enterCaptcha}]}
                                                    style={{display:this.state.loginVisible?"":"none"}}
                                                >
                                                    <AisinoInput autoComplete="off" maxLength={4}
                                                                 placeholder={loginLan.enterCaptcha}/>
                                                </AisinoFormItem>
                                            </AisinoCol>
                                            <AisinoCol span={6} >
                                                {captchaId?<img style={{width:"100%",height:"38px",position: "absolute",top: "32px"}} src={window.g.baseURL+"/invoice/aos/mainui/login/captcha?captcha_id="+captchaId} onClick={() => this.captchaChange()}/>:''}
                                            </AisinoCol>
                                        </AisinoRow>

                                        <AisinoRow >
                                            <div style={{textAlign:"right",width: "100%"}}>
                                                <a onClick={()=>this.forgetPwdFun()}>{loginLan.forgetPwd}</a>
                                            </div>
                                        </AisinoRow>
                                        <AisinoFormItem  {...tailLayout}
                                                         style={{display:this.state.loginVisible?"":"none"}}
                                        >
                                            <AisinoButton type="primary" htmlType="submit" shape="round" style={{

                                                borderRadius:"3px",
                                                color: "#ffffff",
                                                fontSize:"16px",
                                                fontWeight:"bold"
                                            }}>
                                                {loginLan.login.label}
                                            </AisinoButton>
                                        </AisinoFormItem>
                                        <AisinoRow >
                                            <div>
                                                <span>{loginLan.noAccount}</span><a  onClick={()=>this.registerNowFun()}>{loginLan.registerNow}</a>
                                            </div>
                                        </AisinoRow>
                                    </div>
                                </AisinoForm>
                            </div>
                        </div>
                    </AisinoCol>
                </AisinoRow>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        showMenu:state.showMenu
    }
}
const mapDispathToProps = {
    foo : (data) => {
      return {
        type: "showMenu",
        payload: data
      }
    },
  }
export default connect(mapStateToProps,mapDispathToProps)(Login);
